import {createContext} from 'react';

const QueryBuilderContext = createContext();

export default QueryBuilderContext;
